import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=77aca842&scoped=true&"
import script from "./UiTabs.vue?vue&type=script&lang=js&"
export * from "./UiTabs.vue?vue&type=script&lang=js&"
import style0 from "./UiTabs.vue?vue&type=style&index=0&id=77aca842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aca842",
  null
  
)

export default component.exports